/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface JdbcConnection { 
    url: string;
    username: string;
    password: string;
    databaseType: JdbcConnection.DatabaseTypeEnum;
}
export namespace JdbcConnection {
    export type DatabaseTypeEnum = 'ORACLE' | 'POSTGRES' | 'REDSHIFT' | 'MYSQL';
    export const DatabaseTypeEnum = {
        ORACLE: 'ORACLE' as DatabaseTypeEnum,
        POSTGRES: 'POSTGRES' as DatabaseTypeEnum,
        REDSHIFT: 'REDSHIFT' as DatabaseTypeEnum,
        MYSQL: 'MYSQL' as DatabaseTypeEnum
    };
}
